import { useCallback, useMemo, useState } from 'react';

function useOverlay() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  const ariaAttributes = useMemo(
    () => ({
      'aria-haspopup': true,
      'aria-expanded': isOpen,
    }),
    [isOpen]
  );

  return { isOpen, open, close, toggle, ariaAttributes };
}

export { useOverlay };
